import { render, staticRenderFns } from "./GoodsShoot.vue?vue&type=template&id=116c3d76&scoped=true&"
import script from "./GoodsShoot.vue?vue&type=script&lang=js&"
export * from "./GoodsShoot.vue?vue&type=script&lang=js&"
import style0 from "./GoodsShoot.vue?vue&type=style&index=0&id=116c3d76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116c3d76",
  null
  
)

export default component.exports